import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=36a71284&scoped=true"
import script from "./overview.vue?vue&type=script&lang=js"
export * from "./overview.vue?vue&type=script&lang=js"
import style0 from "./overview.vue?vue&type=style&index=0&id=36a71284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a71284",
  null
  
)

export default component.exports